import { makeObservable, observable } from 'mobx';
import { z } from 'zod';
import type { RequireAllProps } from '../../../../../store/utils/Dto';
import type { AccountSaveMethod } from '../../types';
import Service, { type ServiceDto } from '../Service';

export default class Squarespace extends Service<SquarespaceDto> {
  static Schema = z.object({
    accessToken: z.string().min(1),
    allowUnauthorized: z.boolean(),
    refreshToken: z.string(),
    webhookSecret: z.string(),
    websiteId: z.string(),
  });

  accessToken = '';
  accessTokenExpiresAt = '';
  allowUnauthorized = false;
  refreshToken = '';
  refreshTokenExpiresAt = '';
  webhookSecret = '';
  websiteId = '';

  constructor(dto: SquarespaceDto = {} as any, onSave?: AccountSaveMethod) {
    super(dto, onSave);

    makeObservable(this, {
      accessToken: observable,
      accessTokenExpiresAt: observable,
      allowUnauthorized: observable,
      refreshToken: observable,
      refreshTokenExpiresAt: observable,
      webhookSecret: observable,
      websiteId: observable,
    });

    Object.assign(this, dto);
  }

  toJSON(): RequireAllProps<SquarespaceDto> {
    return {
      ...super.toJSON(),
      accessToken: this.accessToken,
      accessTokenExpiresAt: this.accessTokenExpiresAt,
      allowUnauthorized: this.allowUnauthorized,
      refreshToken: this.refreshToken,
      refreshTokenExpiresAt: this.refreshTokenExpiresAt,
      webhookSecret: this.webhookSecret,
      websiteId: this.websiteId,
    };
  }
}

export interface SquarespaceDto extends ServiceDto {
  accessToken?: string;
  accessTokenExpiresAt?: string;
  allowUnauthorized?: boolean;
  refreshToken?: string;
  refreshTokenExpiresAt?: string;
  webhookSecret?: string;
  websiteId?: string;
}
